import {isTeamValue} from './teamValueHelpers';

/**
 * Resolves which values to keep when a multi-select changes in an assignment dialog.
 *
 * Rules:
 * 1. `null` input → passes through as `null` (clear selection).
 * 2. Adding a team → replaces all previous values with only that team.
 * 3. Adding a user when a team was previously selected → removes teams, keeps only users.
 * 4. Normal add (users only, no team transition) → passes through unchanged.
 */
export function resolveMultiSelectValues(
  previousValues: string[],
  newValues: string[] | null
): string[] | null {
  if (newValues === null) {
    return null;
  }

  const addedValues = newValues.filter((v) => !previousValues.includes(v));
  const hasNewTeam = addedValues.some(isTeamValue);

  if (hasNewTeam) {
    const latestTeam = addedValues.find(isTeamValue);
    return latestTeam ? [latestTeam] : newValues;
  }

  const hadTeamBefore = previousValues.some(isTeamValue);

  if (hadTeamBefore && addedValues.length > 0) {
    return newValues.filter((v) => !isTeamValue(v));
  }

  return newValues;
}
